import { SurveyMessages, TranslationSurveyMessages } from "../interfaces";

export const messages: TranslationSurveyMessages = {
  [SurveyMessages.createSurveySuccess]: "Survey registered successfully",
  [SurveyMessages.createSurveyError]: "Error creating new survey"
};
